import DraftsIcon from '@material-ui/icons/Drafts';
import MouseIcon from '@material-ui/icons/Mouse';
import WarningIcon from '@material-ui/icons/Warning';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import BlockIcon from '@material-ui/icons/Block';
import SendIcon from '@material-ui/icons/Send';
import SmsIcon from '@material-ui/icons/Sms';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import MobileFriendlyIcon from '@material-ui/icons/MobileFriendly';
import ErrorIcon from '@material-ui/icons/Error';
import UnsubscribeIcon from '@material-ui/icons/Unsubscribe';

export const types = {
  REQUESTED: 'REQUESTED',
  ACCEPTED: 'ACCEPTED',
  DELIVERED: 'DELIVERED',
  SENT: 'SENT',
  OPENED: 'OPENED',
  CLICKED: 'CLICKED',
  BOUNCED: 'BOUNCED',
  BLOCKED: 'BLOCKED',
  UNSUBSCRIBED: 'UNSUBSCRIBED'
};

export const smsTypes = {
  SENT: 'SMS_SENT',
  DELIVERED: 'SMS_DELIVERED',
  ACCEPTED: 'SMS_ACCEPTED',
  ERRORED: 'SMS_ERRORED'
};

export const labels = {
  [types.REQUESTED]: 'Requested',
  [types.ACCEPTED]: 'Accepted',
  [types.DELIVERED]: 'Delivered',
  [types.SENT]: 'Sent',
  [types.OPENED]: 'Opened',
  [types.CLICKED]: 'Clicked',
  [types.BOUNCED]: 'Bounced',
  [types.BLOCKED]: 'Blocked',
  [types.UNSUBSCRIBED]: 'Unsubscribed',
  [types.SPAM]: 'Spam',
  [smsTypes.SENT]: 'Sent',
  [smsTypes.ACCEPTED]: 'Accepted',
  [smsTypes.DELIVERED]: 'Delivered',
  [smsTypes.ERRORED]: 'Error'
};

export const icons = {
  [types.REQUESTED]: SendIcon,
  [types.ACCEPTED]: CheckCircleIcon,
  [types.DELIVERED]: MobileFriendlyIcon,
  [types.SENT]: SendIcon,
  [types.OPENED]: DraftsIcon,
  [types.CLICKED]: MouseIcon,
  [types.BOUNCED]: SwapHorizIcon,
  [types.BLOCKED]: BlockIcon,
  [types.UNSUBSCRIBED]: UnsubscribeIcon,
  [types.SPAM]: WarningIcon,
  [smsTypes.SENT]: SmsIcon,
  [smsTypes.ACCEPTED]: CheckCircleIcon,
  [smsTypes.DELIVERED]: MobileFriendlyIcon,
  [smsTypes.ERRORED]: ErrorIcon
};

const colorScheme = {
  red: '#721817',
  yellow: '#FFC800',
  orange: '#FE5D26',
  green: '#43A047',
  blue: '#496DDB',
  grey: '#443742'
};

export const colors = {
  [types.REQUESTED]: colorScheme.green,
  [types.ACCEPTED]: colorScheme.green,
  [types.DELIVERED]: colorScheme.blue,
  [types.SENT]: colorScheme.green,
  [types.OPENED]: colorScheme.blue,
  [types.CLICKED]: colorScheme.grey,
  [types.BOUNCED]: colorScheme.yellow,
  [types.BLOCKED]: colorScheme.orange,
  [types.UNSUBSCRIBED]: colorScheme.red,
  [types.SPAM]: colorScheme.red,
  [smsTypes.SENT]: colorScheme.green,
  [smsTypes.ACCEPTED]: colorScheme.green,
  [smsTypes.DELIVERED]: colorScheme.blue,
  [smsTypes.FAILED]: colorScheme.red
};

export const paramKeys = {
  statBoxTimeRange: 'sbtr'
};

export const paramValues = {
  [paramKeys.statBoxTimeRange]: {
    currentDay: 'cd',
    previousWeek: 'p7',
    previousMonth: 'mtd'
  }
};
